/**
 * How tall a usage list may grow before it scrolls inside its own card.
 *
 * Row counts here are unbounded — one per tenant, one per feature, one per
 * model Vertex served — so without a cap the tab's height is set by whatever
 * the window happens to contain, and the panels at the bottom drift out of
 * reach on a busy day. Capping keeps the page a fixed length whatever the data
 * does, and each card scrolls in place under a header that stays put.
 *
 * The model table gets the taller cap because it answers the question the tab
 * exists for; the rest are read after it.
 */
export const PRIMARY_LIST_MAX_HEIGHT = "max-h-96";
export const SECONDARY_LIST_MAX_HEIGHT = "max-h-80";

/**
 * Keeps the column headers legible over the rows sliding beneath them.
 * Stay at z-[1]: a page-level z-10 lets sticky heads paint over chart tooltips
 * that overflow the plot into the table below.
 */
export const STICKY_HEAD_CLASS = "sticky top-0 z-[1] bg-card";
